// eslint-disable-next-line import/prefer-default-export
export const passesConditions = (conditions, requestContext) => {
    if (conditions.loggedIn && !requestContext.customer) {
        // console.log('loggedIn condition fails');
        return false;
    }
    if (conditions.accessGroups) {
        // console.log('Current Customer AccessGroups', requestContext.accessGroups);
        const groupsResult = Object.entries(conditions.accessGroups).every(([key, requirement]) => {
            // for (const [key, requirement] of Object.entries(conditions.accessGroups) {
            // if requirement is 'member' make sure customer is in group
            if (requirement === 'member'
                && (!requestContext.accessGroups
                    || !requestContext.accessGroups.includes(key))) {
                // console.log('Customer not in group, but needs to be', key);
                return false;
            }
            if (requirement === 'notMember'
                && requestContext.accessGroups
                && requestContext.accessGroups.includes(key)) {
                // console.log('Customer in group, but needs to not be', key);
                return false;
            }
            return true;
        });
        if (!groupsResult) {
            return false;
        }
    }
    // add additional conditions here
    // everything has passed
    return true;
};
//# sourceMappingURL=displayConditions.js.map